import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, PaginationProps, ShortMutationConfigType } from "../../utils/api.type"
import { CreateBuildingProps, CreateBuildingResponse, DeleteBuildingProps, DetailBuildingResponse, ListBuildingResponse, UpdateBuildingProps } from "./building.type"


const GET_BUILDING = '/v1/rms/config/building/'
export const useListBuilding = (obj = {} as GeneralProps & PaginationProps) => {
  return useRequest<ListBuildingResponse>(GET_BUILDING, {
    ...obj,
    page_size: obj.page_size || 9,
    page: obj.page || 1,
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const GET_BUILDING_DETAIL = '/v1/rms/config/building/detail/:buildingId/'
export const useGetBuildingDetail = (buildingId: string, obj = {} as GeneralProps) => {
  return useRequest<DetailBuildingResponse>(GET_BUILDING_DETAIL.replace(':buildingId', buildingId), { ...obj }, {
    enabled: obj.enabled !== false && !!buildingId,
    cache: false
    // cacheKey: JSON.stringify({ ...obj, buildingId }),
  })
}

const ENDPOINT_CREATE_BUILDING = '/v1/rms/config/building/store/'
export const useCreateBuildingMutation = (options: ShortMutationConfigType) => {
  return useMutation<CreateBuildingResponse, CreateBuildingProps>(ENDPOINT_CREATE_BUILDING, options)
}

const ENDPOINT_DELETE_BUILDING = '/v1/rms/config/building/delete/'
export const useDeleteBuildingMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, DeleteBuildingProps>(ENDPOINT_DELETE_BUILDING, {
    ...options,
    method: "DELETE"
  })
}

const ENDPOINT_UPDATE_BUILDING = '/v1/rms/config/building/update/:buildingId/'
export const useUpdateBuildingMutation = (options: ShortMutationConfigType & { buildingId: string }) => {
  return useMutation<CreateBuildingResponse, UpdateBuildingProps>(ENDPOINT_UPDATE_BUILDING.replace(':buildingId', options.buildingId), {
    ...options,
    method: "POST"
  })
}